/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useLocation } from 'react-router-dom-v5-compat'
import { UltyLinkLabel } from '../Shared/UltyLinkLabel/UltyLinkLabel'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import { useTranslation } from 'react-i18next'
import useUser from '../Shared/UserProvider/useUser'
import useFeature from '../Shared/FeatureProvider/useFeature'

const Tabs = () => {
    const {user} = useUser()
    const {isEnabled} = useFeature()
    const [t] = useTranslation()
    const location = useLocation()
    const canAccessMargin = isEnabled('margin') && isProviderAPos(user.provider)

    if (!canAccessMargin) {
        return null
    }

    return (
      <div
        css={css`
            display: flex;
            column-gap: 1rem;
            width: 210px;
        `}
      >
          <UltyLinkLabel
            css={css`flex: 1`}
            to={'/products'}
            active={location.pathname === '/products'}
          >
              {t('product_list.products')}
          </UltyLinkLabel>

          {canAccessMargin && (
            <UltyLinkLabel
              css={css`flex: 1`}
              to={'/products/margin'}
              active={location.pathname === '/products/margin'}
            >
                {t('margin.title')}
            </UltyLinkLabel>
          )}
      </div>
    )
}

export { Tabs }
